import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';
import AdminLayout from '../../components/admin/AdminLayout';
import ProductForm from '../../components/admin/ProductForm';
import styles from './ProductManagement.module.css';

const ProductManagement = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Traer categorías del backend usando apiService
    apiService.getCategories()
      .then(data => setCategories(data || []))
      .catch(() => setCategories([]));
  }, []);

  return (
    <AdminLayout>
      <div className={styles.productManagement}>
        <div className={styles.header}>
          <h1>Agregar Nuevo Producto</h1>
        </div>

        <ProductForm categories={categories} />
      </div>
    </AdminLayout>
  );
};

export default ProductManagement;